//#region Libraries
//#endregion
//#region Styles
import {
	Part,
	Fields,
	Column,
	TitleSection,
	SubtitleSection,
} from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import OnlyDayFields from "views/components/Duration/OnlyDayFields/OnlyDayFields";
import ManyDaysFields from "views/components/Duration/ManyDaysFields/ManyDaysFields";
import useFilterInactivitiesOutOfRangeWhenDateOrTimeChanges from "./utils/hooks/useFilterInactivitiesOutOfRangeWhenDateOrTimeChanges";
//#endregion
//#region Utils
import { EVENTS_CONSTANTS, EVENT_PERIODS } from "config/constants";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const Part2 = ({ form, errors, changeField, allDays }) => {
	const { periodId, duration } = form;
	const { onlyDay, manyDays } = duration;
	//#region Functions
	const changePeriodId = value => {
		changeField("periodId", value, false);
	};
	const changeDuration = (field, value, errorValue) => {
		changeField(
			"duration",
			{
				...duration,
				[field]: value,
			},
			{
				...errors.duration,
				[field]: errorValue,
			}
		);
	};
	const changeDurationOnlyDayFields = (value, errorValue) =>
		changeDuration("onlyDay", value, errorValue);
	const changeDurationManyDaysFields = (value, errorValue) =>
		changeDuration("manyDays", value, errorValue);
	//#endregion
	useFilterInactivitiesOutOfRangeWhenDateOrTimeChanges({
		duration,
		errors: errors.duration,
		change: {
			changeDurationOnlyDayFields,
			changeDurationManyDaysFields,
		},
	});
	return (
		<Part paddingBottom="20px">
			<Fields>
				<Column>
					<Column>
						<TitleSection>Duración</TitleSection>
					</Column>
				</Column>
				<Column>
					<SubtitleSection>Periodo: </SubtitleSection>
					<HandlerRadio
						value={periodId}
						radiosProps={EVENT_PERIODS}
						onChange={changePeriodId}
						error={errors.periodId}
						errorText="Es necesario seleccionar un período"
					/>
				</Column>
				{!periodId ? (
					<NotificationNoContent
						title="Aun no has señalado un periodo"
						description="Selecciona uno para mostrarte las opciones de fechas y horas"
					/>
				) : periodId === EVENT_PERIOD_IDS.ONLY_DAY ? (
					<OnlyDayFields
						duration={onlyDay}
						errors={errors.duration.onlyDay}
						changeDuration={changeDurationOnlyDayFields}
						direction="column"
						ratioMinutesTimeForTimePickers={60}
					/>
				) : (
					periodId === EVENT_PERIOD_IDS.MANY_DAYS && (
						<ManyDaysFields
							duration={manyDays}
							errors={errors.duration.manyDays}
							changeDuration={changeDurationManyDaysFields}
							allDays={allDays}
							ratioMinutesTimeForTimePickers={60}
							hasInactivity
						/>
					)
				)}
			</Fields>
		</Part>
	);
};

export default Part2;
